export default "__VITE_ASSET__DiJWdnZT__"